import {apiGET} from "./RequestsCore";


/**
 * Returns all the available statuses for the logged user (the user who requests).
 *
 * @param type
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function getAvailableStatuses(type = null) {
    let data = {};

    if (type !== null) {
        data.type = type;
    }

    return apiGET('/api/statuses', data);
}
